<template>
  <div>
    <!-- 拼合 -->
    <div style="display: flex">
      <iframe id="iframe_home" :src="src" width="380px" height="675px" />
      <iframe :src="adSrc" height="675px" style="flex: 1" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      src: 'home',
      adSrc: 'advertisement',
      domain: process.env.VUE_APP_PAGE_URL
    }
  },
  watch: {
    '$route'() {
      console.log(this.$route)
    }
  },
  created() {
    let src = ''
    if (this.$route.query.page) {
      if (this.$route.query.guid) {
        src = `${this.$route.query.page}?guid=${this.$route.query.guid}`
      } else {
        src = this.$route.query.page
      }
    } else {
      src = 'home'
    }
    this.src = `${this.domain}${src}`
    this.adSrc = `${this.domain}advertisement`
    this.init()
  },
  methods: {
    init() {
      window.handleWIFIstate = (data) => {
        document.getElementById('iframe_home').contentWindow.handleWIFIstate(data)
      }
      window.handleVideo = (data) => {
        document.getElementById('iframe_home').contentWindow.handleVideo(data)
      }
      window.handleUserVideo = (data) => {
        document.getElementById('iframe_home').contentWindow.handleUserVideo(data)
      },
      window.cancelWiFi = (data) => {
        document.getElementById('iframe_home').contentWindow.cancelWiFi(data)
      }
       window.clickNativeBack = () => {
        document.getElementById('iframe_home').contentWindow.clickNativeBack()
      }
    }
  }
}
</script>
<style scoped>
.demo {
  width:375px
}
iframe {
  border: 0
}
.login{
  font-family:PingFangSC-Regular,PingFang SC;
  background:url('../../icons/loginbg.png');
  background-size: 100% 100%;
  box-sizing: border-box;
}
.contentBox{
  background: white;
  display: flex;
}
.iptDiv{
  display: flex;
}
.iptDiv input{
  border: none
}
.loginBtn{
  background:rgba(0,121,242,1);
  text-align: center;
  color: white;
}

</style>
